class ToolTipController {
  constructor($element, $timeout, $compile) {
    'ngInject';

    this.$element = $element;
    this.$compile = $compile;
    this.$timeout = $timeout;
  }

  $onInit() {
    this.icon = this.$element.attr('set-icon');
    if (typeof this.$element.attr('data-content') !== 'undefined') {
        let $content = $('<div class="hidden">' + this.$element.data('content') + '</div>');
        this.$element.after($content);

        let scope = angular.element($content).scope();
        let compiled = this.$compile($content)(scope);
        this.$timeout(() => {
            this.$element.attr('data-original-title', compiled.get(0).innerHTML);
        }, 500);
    }

    this.$element.tooltip();
  }
}

export default ToolTipController;



// WEBPACK FOOTER //
// ./client/app/shared/ui/tooltip/tooltip.controller.js